import { QuadroCompensiParcella } from '../../models/quadro-compensi-parcella';

export abstract class ParcellaAbstractForm {
  quadroCompensiGrid: QuadroCompensiParcella[] = [];

  // Se il risultato e' false implica che non ci sono fasi selezionate
  checkAtLeastOneFase(): boolean {
    let result: boolean = false;
    if (this.quadroCompensiGrid && this.quadroCompensiGrid.length > 0) {
      for (let q of this.quadroCompensiGrid) {
        if (q.checkedFase) {
          result = true;
          break;
        }
      }
    }
    return result;
  }

  checkAtLeastOneCompenso(): boolean {
    let result: boolean = false;
    if (this.quadroCompensiGrid && this.quadroCompensiGrid.length > 0) {
      for (let q of this.quadroCompensiGrid) {
        if (q.compenso) {
          let compensoString: string = '' + q.compenso;
          compensoString = compensoString.replace('.', '');
          compensoString = compensoString.replace(',', '.');
          let compenso: number = +compensoString;
          if (compenso > 0) {
            result = true;
            break;
          }
        }
      }
    }
    return result;
  }
}
